import { useEffect, useRef } from 'react'

interface RequestTracker {
  addRequest: (requestId: string) => void
  removeRequest: (requestId: string) => void
  hasActiveRequests: () => boolean
}

// Global request tracker
const activeRequests = new Set<string>()
let requestCounter = 0

export const requestTracker: RequestTracker = {
  addRequest: (requestId: string) => {
    activeRequests.add(requestId)
  },
  removeRequest: (requestId: string) => {
    activeRequests.delete(requestId)
  },
  hasActiveRequests: () => {
    return activeRequests.size > 0
  },
}

// Generate unique request ID
export const generateRequestId = (): string => {
  return `req_${++requestCounter}_${Date.now()}`
}

// Hook to prevent page reload when requests are active
export const useRequestTracker = () => {
  return {
    addRequest: requestTracker.addRequest,
    removeRequest: requestTracker.removeRequest,
    hasActiveRequests: requestTracker.hasActiveRequests,
  }
}
